import { render } from "./PreAppInfoBox.vue?vue&type=template&id=99ffb4ba&scoped=true"
import script from "./PreAppInfoBox.vue?vue&type=script&lang=js"
export * from "./PreAppInfoBox.vue?vue&type=script&lang=js"

import "./PreAppInfoBox.vue?vue&type=style&index=0&id=99ffb4ba&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99ffb4ba"]])

export default __exports__